import { PERMISSION_GROUPS, SYSTEM_PERMISSIONS, CLIENT_PERMISSIONS, LINK_PERMISSIONS, DOMAIN_PERMISSIONS, RULE_PERMISSIONS, VISITOR_PERMISSIONS, STATS_PERMISSIONS, BILLING_PERMISSIONS } from '../constants/permissions';

export interface MenuItem {
  key: string;
  label: string;
  icon?: string;
  permission?: string;
  children?: MenuItem[];
  path?: string;
  featureFlag?: string; // 功能开关标识
}

export const ADMIN_MENU_ITEMS: MenuItem[] = [
  {
    key: 'dashboard',
    label: '仪表板',
    icon: 'DashboardOutlined',
    permission: STATS_PERMISSIONS.READ,
    path: '/dashboard',
  },


  {
    key: 'links',
    label: '链接管理',
    icon: 'LinkOutlined',
    permission: LINK_PERMISSIONS.READ,
    path: '/links',
  },


  {
    key: 'rules',
    label: '拦截规则',
    icon: 'SecurityScanOutlined',
    permission: RULE_PERMISSIONS.READ,
    path: '/rules',
  },
  {
    key: 'blacklist',
    label: '黑名单管理',
    icon: 'UserOutlined',
    permission: VISITOR_PERMISSIONS.READ,
    path: '/blacklist',
  },
  // {
  //   key: 'ip-list',
  //   label: 'IP黑白名单',
  //   icon: 'SecurityScanOutlined',
  //   permission: VISITOR_PERMISSIONS.READ,
  //   path: '/ip-list',
  // },
  {
    key: 'visitors',
    label: '访客记录',
    icon: 'EyeOutlined',
    permission: VISITOR_PERMISSIONS.READ,
    path: '/visitors',
  },
  {
    key: 'ip-stats',
    label: 'IP访问统计',
    icon: 'BarChartOutlined',
    permission: VISITOR_PERMISSIONS.READ,
    path: '/ip-stats',
  },
  {
    key: 'statistics',
    label: '统计分析',
    icon: 'BarChartOutlined',
    permission: STATS_PERMISSIONS.READ,
    path: '/statistics',
  },
  {
    key: 'pixel',
    label: '增值功能',
    icon: 'MoneyCollectOutlined',
    permission: STATS_PERMISSIONS.READ,
    featureFlag: 'enable_pixel_feature',
    children: [
      {
        key: 'pixel-config',
        label: '像素配置',
        permission: STATS_PERMISSIONS.READ,
        path: '/pixel-config',
      },
      {
        key: 'postback-logs',
        label: '回传记录',
        permission: STATS_PERMISSIONS.READ,
        path: '/postback-logs',
      },
    ],
  },
  {
    key: 'referral-admin',
    label: '推广管理',
    icon: 'TeamOutlined',
    permission: SYSTEM_PERMISSIONS.CLIENT_READ,
    path: '/referral-admin',
  },
  {
    key: 'billing',
    label: '计费中心',
    icon: 'MoneyCollectOutlined',
    permission: BILLING_PERMISSIONS.PLAN_READ,
    path: '/billing',
  },

  {
    key: 'domains',
    label: '域名管理',
    icon: 'LinkOutlined',
    permission: DOMAIN_PERMISSIONS.READ,
    path: '/domains',
  },

  {
    key: 'usage',
    label: '用量管理',
    icon: 'MoneyCollectOutlined',
    permission: SYSTEM_PERMISSIONS.USAGE_READ,
    path: '/usage',
  },
  {
    key: 'users',
    label: '用户管理',
    icon: 'UserOutlined',
    permission: CLIENT_PERMISSIONS.SUB_ACCOUNT_READ,
    path: '/users',
  },

  {
    key: 'operation-logs',
    label: '操作记录',
    icon: 'HistoryOutlined',
    permission: SYSTEM_PERMISSIONS.SECURITY_READ,
    path: '/operation-logs',
  },
  {
    key: 'docs',
    label: '帮助文档',
    icon: 'BookOutlined',
    children: [
      {
        key: 'docs-manual',
        label: '使用文档',
        path: '/docs/manual',
      },
    ],
  },
  {
    key: 'system',
    label: '系统管理',
    icon: 'SettingOutlined',
    permission: SYSTEM_PERMISSIONS.ALL,
    children: [
      {
        key: 'system-config',
        label: '系统配置',
        permission: SYSTEM_PERMISSIONS.CONFIG_READ,
        path: '/system/config',
      },
      {
        key: 'system-monitor',
        label: '系统监控',
        permission: SYSTEM_PERMISSIONS.MONITOR_READ,
        path: '/system/monitor',
      },
      {
        key: 'system-security',
        label: '安全管理',
        permission: SYSTEM_PERMISSIONS.SECURITY_READ,
        path: '/system/security',
      },
    ],
  },
];

export const CLIENT_MENU_ITEMS: MenuItem[] = [
  {
    key: 'dashboard',
    label: '仪表板',
    icon: 'DashboardOutlined',
    permission: STATS_PERMISSIONS.READ,
    path: '/dashboard',
  },
  {
    key: 'links',
    label: '链接管理',
    icon: 'LinkOutlined',
    permission: LINK_PERMISSIONS.READ,
    path: '/links',
  },
  {
    key: 'rules',
    label: '拦截规则',
    icon: 'SecurityScanOutlined',
    permission: RULE_PERMISSIONS.READ,
    path: '/rules',
  },
  {
    key: 'blacklist',
    label: '黑名单管理',
    icon: 'UserOutlined',
    permission: VISITOR_PERMISSIONS.READ,
    path: '/blacklist',
  },

  {
    key: 'visitors',
    label: '访客记录',
    icon: 'EyeOutlined',
    permission: VISITOR_PERMISSIONS.READ,
    path: '/visitors',
  },

  {
    key: 'statistics',
    label: '统计分析',
    icon: 'BarChartOutlined',
    permission: STATS_PERMISSIONS.READ,
    path: '/statistics',
  },
  {
    key: 'pixel',
    label: '增值功能',
    icon: 'MoneyCollectOutlined',
    permission: STATS_PERMISSIONS.READ,
    featureFlag: 'enable_pixel_feature',
    children: [
      {
        key: 'pixel-config',
        label: '像素配置',
        permission: STATS_PERMISSIONS.READ,
        path: '/pixel-config',
      },
      {
        key: 'postback-logs',
        label: '回传记录',
        permission: STATS_PERMISSIONS.READ,
        path: '/postback-logs',
      },
    ],
  },
  {
    key: 'referral',
    label: '推广返佣',
    icon: 'TeamOutlined',
    permission: STATS_PERMISSIONS.READ,
    path: '/referral',
  },
  {
    key: 'domains',
    label: '域名管理',
    icon: 'LinkOutlined',
    permission: DOMAIN_PERMISSIONS.READ,
    path: '/domains',
  },
  {
    key: 'billing',
    label: '计费中心',
    icon: 'MoneyCollectOutlined',
    permission: BILLING_PERMISSIONS.SUBSCRIPTION_READ,
    path: '/billing',
  },
  {
    key: 'users',
    label: '子账号管理',
    icon: 'UserOutlined',
    permission: CLIENT_PERMISSIONS.SUB_ACCOUNT_READ,
    path: '/users',
  },
  {
    key: 'docs',
    label: '帮助文档',
    icon: 'BookOutlined',
    children: [
      {
        key: 'docs-manual',
        label: '使用文档',
        path: '/docs/manual',
      },
    ],
  },
];

export const SUB_ACCOUNT_MENU_ITEMS: MenuItem[] = [
  {
    key: 'dashboard',
    label: '仪表板',
    icon: 'DashboardOutlined',
    permission: STATS_PERMISSIONS.READ,
    path: '/dashboard',
  },
  {
    key: 'links',
    label: '链接管理',
    icon: 'LinkOutlined',
    permission: LINK_PERMISSIONS.READ,
    path: '/links',
  },
  {
    key: 'rules',
    label: '拦截规则',
    icon: 'SecurityScanOutlined',
    permission: RULE_PERMISSIONS.READ,
    path: '/rules',
  },
  {
    key: 'blacklist',
    label: '黑名单管理',
    icon: 'UserOutlined',
    permission: VISITOR_PERMISSIONS.READ,
    path: '/blacklist',
  },

  {
    key: 'visitors',
    label: '访客记录',
    icon: 'EyeOutlined',
    permission: VISITOR_PERMISSIONS.READ,
    path: '/visitors',
  },

  {
    key: 'statistics',
    label: '统计分析',
    icon: 'BarChartOutlined',
    permission: STATS_PERMISSIONS.READ,
    path: '/statistics',
  },
  {
    key: 'pixel',
    label: '增值功能',
    icon: 'MoneyCollectOutlined',
    permission: STATS_PERMISSIONS.READ,
    featureFlag: 'enable_pixel_feature',
    children: [
      {
        key: 'pixel-config',
        label: '像素配置',
        permission: STATS_PERMISSIONS.READ,
        path: '/pixel-config',
      },
      {
        key: 'postback-logs',
        label: '回传记录',
        permission: STATS_PERMISSIONS.READ,
        path: '/postback-logs',
      },
    ],
  },
  {
    key: 'referral',
    label: '推广返佣',
    icon: 'TeamOutlined',
    permission: STATS_PERMISSIONS.READ,
    path: '/referral',
  },
  {
    key: 'domains',
    label: '域名管理',
    icon: 'LinkOutlined',
    permission: DOMAIN_PERMISSIONS.READ,
    path: '/domains',
  },
  {
    key: 'docs',
    label: '帮助文档',
    icon: 'BookOutlined',
    children: [
      {
        key: 'docs-manual',
        label: '使用文档',
        path: '/docs/manual',
      },
    ],
  },
  // {
  //   key: 'billing',
  //   label: '计费中心',
  //   icon: 'CreditCardOutlined',
  //   permission: BILLING_PERMISSIONS.SUBSCRIPTION_READ,
  //   path: '/billing',
  // },
];

export const PERMISSION_TEST_MENU_ITEMS: MenuItem[] = [
  {
    key: 'permission-test',
    label: '权限测试',
    icon: 'SecurityScanOutlined',
    permission: STATS_PERMISSIONS.READ,
    path: '/permission-test',
  },
];

export const getMenuItemsByUserType = (userType: 'admin' | 'client' | 'sub'): MenuItem[] => {
  switch (userType) {
    case 'admin':
      return ADMIN_MENU_ITEMS;
    case 'client':
      return CLIENT_MENU_ITEMS;
    case 'sub':
      return SUB_ACCOUNT_MENU_ITEMS;
    default:
      return [];
  }
};

export const filterMenuByPermissions = (
  menuItems: MenuItem[],
  permissions: string[] | undefined,
  featureFlags?: Record<string, boolean | undefined>
): MenuItem[] => {
  console.log('🔍 过滤菜单权限 - 菜单项:', menuItems, '权限:', permissions, '功能开关:', featureFlags);

  // 安全检查：如果permissions为undefined或null，返回原始菜单项（不进行过滤）
  if (!permissions || !Array.isArray(permissions)) {
    console.log('⚠️ 权限未定义，返回原始菜单项');
    return menuItems;
  }

  const hasSuperPermission = permissions.includes('*:*');

  const filteredItems = menuItems.filter(item => {
    // 检查功能开关
    if (item.featureFlag && featureFlags) {
      const isEnabled = featureFlags[item.featureFlag];
      // 只有明确设置为 false 时才隐藏，undefined 或 true 都显示
      if (isEnabled === false) {
        console.log(`🚫 功能开关关闭:`, item.label, item.featureFlag);
        return false;
      }
    }

    // 如果没有权限要求，直接通过
    if (!item.permission) {
      console.log('✅ 菜单项无权限要求:', item.label);
      return true;
    }

    // 检查权限
    const hasPermission = hasSuperPermission || permissions.includes(item.permission);
    console.log(`🔍 检查权限 ${item.permission} 结果:`, hasPermission, '菜单项:', item.label);

    if (!hasPermission) {
      return false;
    }

    // 递归处理子菜单
    if (item.children) {
      item.children = filterMenuByPermissions(item.children, permissions, featureFlags);
      if (item.children.length === 0) {
        return false;
      }
    }

    return true;
  });

  console.log('📋 过滤后的菜单项:', filteredItems);
  return filteredItems;
};

export const getAllMenuItems = (): MenuItem[] => {
  return [
    ...ADMIN_MENU_ITEMS,
    ...CLIENT_MENU_ITEMS,
    ...SUB_ACCOUNT_MENU_ITEMS,
    ...PERMISSION_TEST_MENU_ITEMS,
  ];
};

export const getMenuItemByPath = (path: string, menuItems: MenuItem[]): MenuItem | null => {
  for (const item of menuItems) {
    if (item.path === path) {
      return item;
    }
    if (item.children) {
      const childItem = getMenuItemByPath(path, item.children);
      if (childItem) {
        return childItem;
      }
    }
  }
  return null;
};
